// extracted by mini-css-extract-plugin
export default {"inboxFooter":"PortalCommunicationInbox_inboxFooter__yOVtG","buttonGroupContainer":"PortalCommunicationInbox_buttonGroupContainer__GZvKz"};